module.exports = __webpack_public_path__ + "img/excel.b092ae84.svg";